<script setup>
import { onBeforeUnmount, ref } from 'vue';
import Avatar from '../ava/Avatar.vue';
import AvatarGroup from '../ava/AvatarGroup.vue';
import { DisposalGroup, LocalProps } from '../localProps';

const awareness = ref()


const disposals = new DisposalGroup(
  LocalProps.listen(LocalProps.AWARENESS, states => {    
    awareness.value = new Map(states); 
  })
)

onBeforeUnmount(() => {
  disposals()
})

// "name": "Val", "color": "#ffcc00", "id": "unique-user-id" 

function getInitials(name) {
  if (!name) {
    return '?'
  }
  return name.split(/\s+/)
    .filter(p => !!p)
    .map(p => p[0].toUpperCase())
    .slice(0, 3) // max three symbols
    .join('');
}

</script>

<template>


  <AvatarGroup v-if="awareness">  

    <Avatar       
      v-for="a in awareness.values()" 
      :displayName="a.user?.name"
      :initials="getInitials(a.user?.name)"
      :style="`border-color: ${a.user?.color}`"
    />
  </AvatarGroup>
  <AvatarGroup v-else style="visibility: hidden;">  
    <Avatar initials="VE" />
  </AvatarGroup>
</template>